export const px = (x: number) => x + 'px';
export const rem = (x: number) => x + 'rem';
